import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const MegaPromotionTemplate = styled.div`
  /* 섹션 타이틀 좌우 여백 20px (하단 컨텐츠 여백과 정렬) */
  .section-title {
    padding: 0 20px 8px;
  }

  .swiper .swiper-wrapper {
    overscroll-behavior-x: contain;
  }

  .content-title {
    font-size: 18px !important;
  }

  .corner-navi {
    &.corner-navi1 {
      &.fixed {
        height: 50px;
      }
    }

    &.corner-navi2 {
      &.fixed {
        height: 44px;
      }
    }

    &.fixed {
      .event-navigation,
      .event-navigation-type2 {
        position: fixed;
        top: 49px;
        z-index: 90;
      }
    }
  }

  .corner-advertisement .tag {
    margin-bottom: 0;
  }

  .corner-quick-menu {
    margin-top: 0 !important;
    overflow: hidden;
    padding-top: 12px;
    padding-bottom: 12px;

    .btn {
      flex-shrink: 0;
      padding: 6px 12px 6px 6px;
      border: 1px solid #ebebeb;
      background-color: #fff;
    }
  }

  .corner-lp-wrap {
    padding-top: 8px;
    background: #f6f6f6;

    &.fixed .filter-listbar {
      z-index: 2;

      .inner {
        position: fixed;
        top: 49px;
        left: 0;
        right: 0;
      }
    }

    .sorting-bar,
    .product-list,
    .empty-box {
      background: #fff;
    }

    .evt-ctg-navigation-wrap {
      position: relative;

      .evt-ctg-navigation {
        position: relative;

        .area-click {
          max-width: 132px;
          ${mixin.ellipsis(1)};
        }

        .item.active .area-click {
          max-width: 158px;
        }

        .mnbrtm-inner {
          vertical-align: top;
        }
      }
    }

    &.fixed .evt-ctg-navigation-wrap {
      z-index: 2;

      .evt-ctg-navigation {
        position: fixed;
        top: 49px;
        left: 0;
        right: 0;
      }
    }
  }

  .corner-collection-section.fixed .category-tab .menubar-swiper {
    position: fixed;
    top: 49px;
    left: 0;
    right: 0;
    z-index: 2;
  }

  &.special-price-template .event-special-price-product {
    padding: 14px 0 145px;
  }

  &.ranking-template .corner-ranking-product {
    padding-bottom: 145px;
  }

  .corner-mobile-share {
    ${mixin.flex({ align: 'center', justify: 'space-between' })};
    padding: 32px 20px;

    .text {
      line-height: 130%;
      font-size: 16px;
      font-weight: 600;
    }

    .btn-wrap {
      ${mixin.flex({ align: 'center', justify: 'space-between' })};
      column-gap: 16px;

      .btn {
        width: 40px;
        height: 40px;
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .section-title {
      padding: ${mixin.pxToVw('0 20 8')};
    }

    .content-title {
      font-size: ${mixin.pxToVw('18')} !important;
    }

    .corner-navi {
      &.corner-navi1 {
        &.fixed {
          height: ${mixin.pxToVw('50')};
        }
      }

      &.corner-navi2 {
        &.fixed {
          height: ${mixin.pxToVw('44')};
        }
      }

      &.fixed {
        .event-navigation,
        .event-navigation-type2 {
          top: ${mixin.pxToVw('49')};
        }
      }
    }

    .corner-quick-menu {
      padding-top: ${mixin.pxToVw('12')};
      padding-bottom: ${mixin.pxToVw('12')};

      .btn {
        padding: ${mixin.pxToVw('6 12 6 6')};
      }
    }

    .corner-lp-wrap {
      padding-top: ${mixin.pxToVw('8')};

      &.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation,
      &.fixed .filter-listbar .inner {
        top: ${mixin.pxToVw('49')};
      }

      .evt-ctg-navigation-wrap .evt-ctg-navigation {
        .area-click {
          max-width: ${mixin.pxToVw('132')};
        }

        .item.active .area-click {
          max-width: ${mixin.pxToVw('158')};
        }
      }
    }

    .corner-collection-section.fixed .category-tab .menubar-swiper {
      top: ${mixin.pxToVw('49')};
    }

    &.special-price-template .event-special-price-product {
      padding: ${mixin.pxToVw('14 0 145')};
    }

    &.ranking-template .corner-ranking-product {
      padding-bottom: ${mixin.pxToVw('145')};
    }

    .corner-mobile-share {
      padding: ${mixin.pxToVw('32 20')};

      .text {
        font-size: ${mixin.pxToVw('16')};
      }

      .btn-wrap {
        column-gap: ${mixin.pxToVw('16')};

        .btn {
          width: ${mixin.pxToVw('40')};
          height: ${mixin.pxToVw('40')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 1440px;
    margin: 0 auto;

    /* PC는 좌우 여백 없음 (위 20px 오버라이드 무효화) */
    .section-title {
      padding: 0 0 16px 0;
    }

    .content-title {
      font-size: 24px !important;
    }

    .corner-navi {
      &.corner-navi1 {
        &.fixed {
          .navi-inner {
            padding: 20px 0;
          }

          &:has(.navi-2line) {
            height: 160px;
          }

          &:has(.navi-3line) {
            height: 220px;
          }
        }
      }

      &.corner-navi2 {
        &.fixed {
          height: 72px;

          .event-navigation-type2 {
            max-width: 1440px;
            left: 50%;
            z-index: 20;
            transform: translateX(-50%);
          }
        }
      }

      &.fixed {
        .event-navigation,
        .event-navigation-type2 {
          top: 0;
        }
      }
    }

    .corner-quick-menu {
      padding-top: 16px;
      padding-bottom: 16px;

      .btn {
        padding: 8px 16px 8px 8px;
      }
    }

    .corner-brand {
      .date-tab {
        margin-top: 20px;
      }

      .event-brand-wrap > div {
        width: auto;
      }

      .brand-product-list {
        .swiper-button-prev,
        .swiper-button-next {
          top: 119.5px;
        }
      }
    }

    .corner-lp-wrap {
      padding: 65px 57px 0 57px;
      background: #fff;

      &.fixed .filter-listbar .inner {
        width: var(--pc-width);
        margin: 0 auto;
        top: 0;
      }

      .filter-listbar {
        height: 77px;
        margin-bottom: 20px;
      }

      .wrap-pagination {
        margin-top: 72px;
      }

      .evt-ctg-navigation-wrap {
        margin-bottom: 40px;

        .evt-ctg-navigation {
          width: var(--pc-width);
          margin: 0px auto;
          padding: 14px 0;
          background-color: #fff;

          .item.active .area-click,
          .area-click {
            max-width: 205px;
          }
        }
      }

      &.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation {
        top: 0;
      }
    }

    .corner-collection-section {
      &.fixed .category-tab .fold-menubar {
        position: fixed;
        top: 0;
        z-index: 1;

        .menubar-swiper {
          position: static;
        }
      }
    }

    .corner-html {
      width: var(--pc-width);
      margin: 0 auto;
    }

    .event-special-price-product {
      .inner {
        width: auto;
      }
    }

    &.special-price-template .event-special-price-product {
      padding: 20px 57px 0;
    }

    &.ranking-template .corner-ranking-product {
      padding: 20px 57px 0;

      .category-tab {
        ${mixin.flex({ wrap: 'wrap', justify: 'flex-start' })};
        gap: 12px;
        margin-bottom: 20px;
      }
    }
  }
`;
